export interface Testimonial {
  initials: string;
  name: string;
  city: string;
  role?: string;
  quote: string;
}
export const shortTestimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'Mariela G.',
  city: 'Córdoba',
  quote: 'Pasé de gritarle cada día a tener conversaciones reales.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  city: 'Rosario',
  quote: 'Hace un año no me hablaba. Hoy me cuenta algo casi todos los días.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  city: 'Buenos Aires',
  quote: 'Ahora negocio con mi hijo en lugar de imponer. Su actitud cambió.'
}];
export const longTestimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'Mariela G.',
  city: 'Córdoba',
  role: 'Mamá de dos',
  quote: 'Mi hijo QUIERE hablar conmigo ahora. Cambié mi forma de escuchar.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  city: 'Rosario',
  role: 'Psicopedagoga',
  quote: 'El Tomo 2 me mostró el error más común: resolver en lugar de escuchar.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  city: 'Buenos Aires',
  role: 'Padre de 3',
  quote: 'Con el Kit SOS pasamos de grito a conversación en 10 minutos.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  city: 'La Plata',
  role: 'Mamá separada',
  quote: 'Los dos papás lo aplicamos desde nuestras casas. Hay consistencia.'
}];